import { useMutation } from '@tanstack/react-query';
import {
  registerBulkEAlert,
  bulkUnsubscribeEAlert,
  bulkUpdateEAlertFilters,
} from '../../../api/bulkEAlerts';

export interface BulkEAlertData {
  organization_id: string;
  tag: string;
  interval: 'daily' | 'weekly' | 'bi-weekly';
  ignore_tag_filter?: boolean;
  // Location parameters (optional)
  city?: string;
  cities?: string[];
  state?: string;
  subdivision?: string;
  // Search parameters (optional)
  q?: string;
  // Property specifications (optional)
  bedrooms?: number;
  bathrooms?: number;
  min_price?: number;
  max_price?: number;
  property_type?: string;
  propertysubtype?: string;
  status?: string;
  // Boolean features (optional)
  waterfront?: boolean;
  pool?: boolean;
  basement?: boolean;
  garage?: boolean;
  // Square footage (optional)
  sqft_min?: number;
  sqft_max?: number;
}

export const useRegisterBulkEAlert = () => {
  // Toast is owned by the calling component's onError so we don't double-fire.
  return useMutation({
    mutationFn: async (data: BulkEAlertData) => {
      return await registerBulkEAlert({
        bulk: true,
        ...data,
      });
    },
  });
};

interface BulkUnsubscribeEAlertData {
  organization_id: string;
  tag?: string;
  ignore_tag_filter?: boolean;
}

export const useBulkUnsubscribeEAlert = () => {
  return useMutation({
    mutationFn: async (data: BulkUnsubscribeEAlertData) => {
      return await bulkUnsubscribeEAlert(data);
    },
  });
};

export interface BulkUpdateEAlertFiltersData {
  bulk: boolean;
  organization_id: string;
  tag: string;
  ignore_tag_filter?: boolean;
  // Location parameters (optional)
  city?: string;
  cities?: string[];
  state?: string;
  subdivision?: string;
  // Search parameters (optional)
  q?: string;
  // Property specifications (optional)
  bedrooms?: number;
  bathrooms?: number;
  min_price?: number;
  max_price?: number;
  property_type?: string;
  propertysubtype?: string;
  status?: string;
  // Boolean features (optional)
  waterfront?: boolean;
  pool?: boolean;
  basement?: boolean;
  garage?: boolean;
  // Square footage (optional)
  sqft_min?: number;
  sqft_max?: number;
}

export const useBulkUpdateEAlertFilters = () => {
  // Toast is owned by the calling component's onError so we don't double-fire.
  return useMutation({
    mutationFn: async (data: BulkUpdateEAlertFiltersData) => {
      return await bulkUpdateEAlertFilters({
        bulk: true,
        organization_id: data.organization_id,
        tag: data.tag,
        ignore_tag_filter: data.ignore_tag_filter,
        city: data.city,
        cities: data.cities,
        state: data.state,
        subdivision: data.subdivision,
        q: data.q,
        bedrooms: data.bedrooms,
        bathrooms: data.bathrooms,
        min_price: data.min_price,
        max_price: data.max_price,
        property_type: data.property_type,
        propertysubtype: data.propertysubtype,
        status: data.status,
        waterfront: data.waterfront,
        pool: data.pool,
        basement: data.basement,
        garage: data.garage,
        sqft_min: data.sqft_min,
        sqft_max: data.sqft_max,
      });
    },
  });
};
